var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbUpGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0556 9.00391C15.5164 7.57689 15.7491 6.32772 15.7491 5.25064C15.7491 2.85197 14.81 1.00323 13.2491 1.00323C12.4023 1.00323 12.1402 1.50747 11.8123 2.75005C11.8295 2.68512 11.6494 3.38401 11.5968 3.57126C11.4958 3.93 11.32 4.54075 11.0697 5.40227C11.063 5.42535 11.0532 5.4471 11.0403 5.46718L8.17359 9.95284C7.49554 11.0138 6.49507 11.8293 5.31919 12.2795L4.06196 12.7609C3.26859 13.0646 2.80797 13.8943 2.96968 14.7283L3.65584 18.267C3.82298 19.1289 4.47629 19.815 5.32909 20.024L13.5786 22.0459C16.1098 22.6663 18.6682 21.1314 19.3121 18.606L20.886 12.4333C21.2612 10.9616 20.3723 9.46441 18.9007 9.08916C18.6786 9.03255 18.4504 9.00391 18.2212 9.00391H15.0556Z",
    fill: "#18c96d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpGreen);
export default __webpack_public_path__ + "static/media/thumb-up-green.137754bea4d41f976c54edf30bcb3894.svg";
export { ForwardRef as ReactComponent };